module.exports = __webpack_public_path__ + "img/icon.fb1bf8fc.svg";